import { type ReactElement } from "react";
import { type ModeClass } from "@/context";

type LabelType = "open" | "close";

interface LabelProps {
  text: string;
  labelType: LabelType;
  modeClass?: ModeClass;
}

export const Label = ({ text, labelType, modeClass = "" }: LabelProps): ReactElement => (
  <div className={`label ${labelType} ${modeClass}`}>
    <span>{text}</span>
  </div>
);
